import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {v4 as uuidv4} from 'uuid';
const USER_API = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpClient) { }

  getUserList(query): Observable<any> {
    return this.http.get(USER_API + "user" + query);
  }
  getUserCategory(query): Observable<any> {
    return this.http.get(USER_API + "user/usercategory" + query);
  }

  getUserDetails(id): Observable<any> {
    return this.http.get(USER_API + "user/" + id);
  }

  updateUser(id, userdata): Observable<any> {
    return this.http.put(USER_API + "user/" + id, userdata);
  }

  generateOtpForAadharVerification(aadharNumber:Object) {
    return this.http.post(USER_API + "kyc-verification/generate-otp",aadharNumber);
  }

  verifyOtpForAadharVerification(verifyOtpInfo:Object) {
    return this.http.post(USER_API + "kyc-verification/dob/verify-otp",verifyOtpInfo);
  }

  panCardVerification(panCardInfo:Object) {
    return this.http.post(USER_API + "kyc-verification/parent/pan-verify",panCardInfo);
  }

  addUser(userdata): Observable<any> {
    return this.http.post(USER_API + "user", userdata);
  }

  addChildUser(userdata): Observable<any> {
    return this.http.post(USER_API + "user/add-child", userdata);
  }

  getUser(id): Observable<any> {
    return this.http.get(USER_API + "user/" + id);
  }
  getUserWithoutAuth(id): Observable<any> {
    return this.http.get(USER_API + "user/v1/" + id);
  }

  getUserListWithoutAuth(query): Observable<any> {
    return this.http.get(USER_API + "user/v1" + query);
  }
  getUserListWithoutAuthForHomePage(query): Observable<any> {
    return this.http.get(USER_API + "user/v1/homePage" + query);
  }
  getUserListData(query): Observable<any> {
    return this.http.get(USER_API + "user/v1/user" + query);
  }
  updateUserKyc(id, userdata): Observable<any> {
    return this.http.put(USER_API + "kyc/update/" + id, userdata);
  }
  addUserKyc(userdata): Observable<any> {
    return this.http.post(USER_API + "kyc", userdata);
  }
  getUserKycDetails(userId): Observable<any> {
    return this.http.get(USER_API + "kyc/" + userId);
  }
  getUserKycDetailsList(query): Observable<any> {
    return this.http.get(USER_API + "kyc/" + query);
  }
  addUserBankDetails(kycid, userdata): Observable<any> {
    return this.http.put(USER_API + "kyc/addBankDetails/" + kycid, userdata);
  }
  sendManyToBank(bankDetails,idempotencyKey): Observable<any> {
    //const idempotencyKey = uuidv4();
    const headers = new HttpHeaders({ 'Idempotency-Key': idempotencyKey });
    return this.http.post(USER_API + "user-redemption", bankDetails,{headers});
  }
  academysendManyToBank(bankDetails): Observable<any> {
    return this.http.post(USER_API + "user-redemption", bankDetails);
  }
  deleteAccountRequest(data): Observable<any> {
    return this.http.post(USER_API + "delete-account-request", data);
  }
  deleteAccountRequestPublic(data): Observable<any> {
    const headers = new HttpHeaders({
      'X-Skip-Auth': 'true',
      'X-Skip-Auth-Redirect': 'true'
    });
    return this.http.post(USER_API + "delete-account-request", data, { headers });
  }
  sendDeleteAccountOtp(data): Observable<any> {
    const headers = new HttpHeaders({
      'X-Skip-Auth': 'true',
      'X-Skip-Auth-Redirect': 'true'
    });
    return this.http.post(USER_API + "delete-account-request/send-otp", data, { headers });
  }
  verifyDeleteAccountOtp(data): Observable<any> {
    const headers = new HttpHeaders({
      'X-Skip-Auth': 'true',
      'X-Skip-Auth-Redirect': 'true'
    });
    return this.http.post(USER_API + "delete-account-request/verify-otp", data, { headers });
  }
  submitSelectedDeleteAccountRequest(data): Observable<any> {
    const headers = new HttpHeaders({
      'X-Skip-Auth': 'true',
      'X-Skip-Auth-Redirect': 'true'
    });
    return this.http.post(USER_API + "delete-account-request/submit-selected", data, { headers });
  }
  getUserSkills(query): Observable<any> {
    return this.http.get(USER_API + "tournamentscore/user-skills" + query);
  }
  getUserRanking(query): Observable<any> {
    return this.http.get(USER_API + "leaderboardscore/user-ranking" + query);
  }
  getGstDataList(id): Observable<any> {
    return this.http.get(USER_API + "gst/" + id);
  }
  getGstDataListAll(query): Observable<any> {
    return this.http.get(USER_API + "gst" + query);
  }
  getUserDeleteRequest(query): Observable<any> {
    return this.http.get(USER_API + "delete-account-request/" + query);
  }
  getUserDeleteRequestPublic(query): Observable<any> {
    const headers = new HttpHeaders({
      'X-Skip-Auth': 'true',
      'X-Skip-Auth-Redirect': 'true'
    });
    return this.http.get(USER_API + "delete-account-request/user/" + query, { headers });
  }
  getAcademyReferrerList(id, query): Observable<any> {
    return this.http.get(USER_API + "user/academy-referral?filterByAcademyUserId=" + id+query);
  }

  getAcademyRefereeActivity(query): Observable<any> {
    return this.http.get(USER_API + "userwallet/referal" + query);
  }

  getUserSkillsForCategoryWise(query): Observable<any> {
    return this.http.get(USER_API + "tournamentscore/user-skillscategory" + query);
  }

  getUserRankingForCategoryWise(query): Observable<any> {
    return this.http.get(USER_API + "tournamentscore/user-skillscategory" + query);
  }
   addUserDocument(userdata): Observable<any> {
    return this.http.post(USER_API + "document", userdata);
  }

  updateUserDocument(id, userdata): Observable<any> {
    return this.http.put(USER_API + "document/" + id, userdata);
  }

  getUserLocations() {
    return this.http.get(USER_API + "user/location");
  }

  addCoach(data) {
    return this.http.post(`${USER_API}user/coach`,data);
  }

  updateCoach(id,data) {
    return this.http.put(`${USER_API}user/coach/${id}`,data);
  }

  addCoachAttendance(data) {
    return this.http.post(`${USER_API}coachattendance`,data);
  }

  updateCoachAttendance(id,data) {
    return this.http.put(`${USER_API}coachattendance/${id}`,data);
  }

  getCoachAttendanceList(query:string) {
    return this.http.get(`${USER_API}coachattendance?${query}`);
  }
  getUserSubscriptions(query:string) {
    return this.http.get(`${environment.apiUrl}usersubscription?${query}`);
  }

  generateUserSubscriptionInvoice(subscriptionId:string) {
    return this.http.get(`${environment.apiUrl}usersubscription/${subscriptionId}/invoice`, { responseType: 'blob' });
  }

  getPlayerBatchEnrolledList(query:string) {
    return this.http.get(`${environment.apiUrl}batchenroll?${query}`);
  }


}
